import { Navigate, useLocation } from "react-router-dom";

export default function LegacySearchRedirect() {
  const location = useLocation();
  return (
    <Navigate to={{ pathname: "/search", search: location.search }} replace />
  );
}
